module.exports = __webpack_public_path__ + "img/personal14.687817a2.png";